// import React, { useState } from 'react';
// import { Box } from '@mui/material';
// import showicon from "../assets/showicon.svg";
// import hide from "../assets/hide.svg"

// const CustomPasswordInput = ({
//   placeholder,
//   value,
//   onChange,
//   name = 'password',
//   width,
//   height = '42px',
//   fontSize = '14px',
//   borderColor = '#091E4224',
//   focusBorderColor = '#006EC2',
//   placeholderColor = '#A0A0A0',
//   borderRadius = '6px',
//   initiallyVisible = false,
//     containerSx = {},
//   ...rest
// }) => {
//   const [show, setShow] = useState(initiallyVisible);

//   const toggleVisibility = () => setShow((prev) => !prev);

//   return (
//     <Box
//       sx={{
//         width: width || '100%',
//         height,
//         display: 'flex',
//         alignItems: 'center',
//         border: `2px solid ${borderColor}`,
//         borderRadius,
//         px: 1.5,
//         '&:focus-within': {
//           border: `2px solid ${focusBorderColor}`,
//         },
//       }}
//     >
//       <Box
//         component="input"
//         type={show ? 'text' : 'password'}
//         name={name}
//         value={value}
//         onChange={onChange}
//         placeholder={placeholder || ''}
//         sx={{
//           border: 'none',
//           outline: 'none',
//           fontSize,
//           width: '100%',
//           height: '100%',
//         fontFamily: 'Poppins, sans-serif',
//           color: '#333',
//           '::placeholder': {
//             color: placeholderColor,
//             opacity: 1,
//           },
//         }}
//         {...rest}
//       />

//       <Box
//         component="img"
//         src={show ? showicon : hide}
//         alt={show ? 'Hide password' : 'Show password'}
//         sx={{
//           width: 20,
//           height: 20,
//           ml: 1,
//           cursor: 'pointer',
//           objectFit: 'contain',
//         }}
//         onClick={toggleVisibility}
//       />
//     </Box>
//   );
// };

// export default CustomPasswordInput;

import React, { useState } from 'react';
import { Box } from '@mui/material';
import showicon from "../assets/showicon.svg";
import hide from "../assets/hide.svg";

const CustomPasswordInput = ({
  placeholder,
  value,
  onChange,
  name = 'password',
  width,
  height = '42px',
  fontSize = '14px',
  borderColor = '#091E4224',
  focusBorderColor = '#006EC2',
  placeholderColor = '#A0A0A0',
  borderRadius = '6px',
  initiallyVisible = false,
  error, // Add error prop
  ...rest
}) => {
  const [show, setShow] = useState(initiallyVisible);

  const toggleVisibility = () => setShow((prev) => !prev);

  return (
    <Box
      sx={{
        width: width || '100%',
        height,
        display: 'flex',
        alignItems: 'center',
        border: error ? '1px solid red' : `2px solid ${borderColor}`, // Error border: 1px red, else 2px borderColor
        borderRadius,
        px: 1.5,
        '&:focus-within': {
          border: `2px solid ${focusBorderColor}`,
        },
      }}
    >
      <Box
        component="input"
        type={show ? 'text' : 'password'}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder || ''}
        sx={{
          border: 'none',
          outline: 'none',
          fontSize,
          width: '100%',
          height: '100%',
          fontFamily: 'Poppins, sans-serif',
          color: '#333',
          '::placeholder': {
            color: placeholderColor,
            opacity: 1,
          },
        }}
        {...rest}
      />
      <Box
        component="img"
        src={show ? showicon : hide}
        alt={show ? 'Hide password' : 'Show password'}
        sx={{
          width: 20,
          height: 20,
          ml: 1,
          cursor: 'pointer',
          objectFit: 'contain',
        }}
        onClick={toggleVisibility}
      />
    </Box>
  );
};

export default CustomPasswordInput;
